import React from 'react'
import PropTypes from 'prop-types'

import { VFInput } from '@vfgroup-oneplatform/foundation/Components'

import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './CustomInput.styles'

const CustomInput = ({
  value,
  label,
  onBlur,
  isError,
  onFocus,
  fieldRef,
  disabled,
  validator,
  errorMessage,
  onChangeText,
  keyboardType,
  showRightIcon,
  rightIconName,
  rightIconPress,
  autoCapitalize,
  resetValidation
}) => {
  const theme = useTheme()

  const baseColor = isError
    ? Colors.vfRed
    : theme.colors.textInput.default.baseColor

  const handleBlur = data => {
    validator(value)
    onBlur(data)
  }

  const handleFocus = data => {
    resetValidation()
    onFocus(data)
  }

  return (
    <VFInput
      label={label}
      value={value}
      disabled={disabled}
      fieldRef={fieldRef}
      onBlur={handleBlur}
      onFocus={handleFocus}
      baseColor={baseColor}
      showHelperText={isError}
      helperText={errorMessage}
      onChangeText={onChangeText}
      keyboardType={keyboardType}
      showRightIcon={showRightIcon}
      rightIconName={rightIconName}
      autoCapitalize={autoCapitalize}
      style={styles.inputText(theme)}
      rightIconPress={rightIconPress}
      tintColor={
        isError ? Colors.vfRed : theme.colors.textInput.default.tintColor
      }
    />
  )
}

CustomInput.propTypes = {
  value: PropTypes.any,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  isError: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  fieldRef: PropTypes.func,
  validator: PropTypes.func,
  onChangeText: PropTypes.func,
  showRightIcon: PropTypes.bool,
  rightIconName: PropTypes.node,
  errorMessage: PropTypes.string,
  keyboardType: PropTypes.string,
  rightIconPress: PropTypes.func,
  resetValidation: PropTypes.func,
  autoCapitalize: PropTypes.string,
}

CustomInput.defaultProps = {
  value: '',
  label: '',
  isError: false,
  disabled: false,
  errorMessage: '',
  rightIconName: '',
  autoCapitalize: undefined,
  onBlur: () => {},
  onFocus: () => {},
  fieldRef: () => {},
  showRightIcon: false,
  onChangeText: () => {},
  keyboardType: 'default',
  rightIconPress: () => {},
  resetValidation: () => {},
  validator: () => {
    return { isError: false, message: '' }
  }
}

export default CustomInput
